<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{ $t(params.type === 'update' ? 'system.text_188' : 'system.text_130', [$t('ai.ai_gateway')]) }}</div>
    <div slot="body">
      <a-form-model ref="form" :model="form" :rules="rules" v-bind="formItemLayout">
        <a-form-model-item :label="$t('table.title.name')" prop="name">
          <a-input v-model="form.name" :disabled="params.type === 'update'" />
        </a-form-model-item>
        <a-form-model-item :label="$t('compute.text_653')" prop="cloudprovider">
          <base-select v-model="form.cloudprovider" resource="cloudproviders" :disabled="params.type === 'update'" :params="cloudProviderParams" isDefaultSelect />
        </a-form-model-item>
        <a-form-model-item :label="$t('ai.collect_logs')" class="mb-0">
          <a-form-model-item v-bind="formItemLayout2" :extra="$t('ai.collect_logs_extra')">
            <a-switch v-model="form.collect_logs" />
          </a-form-model-item>
          <!-- <template v-if="form.collect_logs">
            <a-form-model-item v-bind="formItemLayout2" :label="$t('ai.collect_logs_limit')" prop="collect_logs_limit" :extra="$t('ai.collect_logs_limit_extra', [form.collect_logs_limit])">
              <a-input-number v-model="form.collect_logs_limit" :min="10000" :max="100000" />
            </a-form-model-item>
            <a-form-model-item v-bind="formItemLayout2" :label="$t('ai.collect_logs_over_limit')" prop="collect_logs_over_limit">
              <a-radio-group v-model="form.collect_logs_over_limit">
                <a-radio value="ignore">{{ $t('ai.collect_logs_over_limit_ignore') }}</a-radio>
                <a-radio value="rewrite">{{ $t('ai.collect_logs_over_limit_rewrite') }}</a-radio>
              </a-radio-group>
            </a-form-model-item>
          </template> -->
        </a-form-model-item>
        <a-form-model-item :label="$t('ai.cache_response')" class="mb-0">
          <a-form-model-item v-bind="formItemLayout2" :extra="$t('ai.cache_response_extra')">
            <a-switch v-model="form.cache_response" />
          </a-form-model-item>
          <a-form-model-item v-if="form.cache_response" v-bind="formItemLayout2" :label="$t('ai.cache_response_duration')" prop="cache_ttl" :extra="$t('ai.cache_response_duration_extra')">
            <a-select v-model="form.cache_ttl">
              <a-select-option v-for="item in cacheTtlOptions" :key="item.value" :value="item.value">{{ item.label }}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-form-model-item>
        <a-form-model-item :label="$t('ai.request_rate_limit')" :extra="rateLimitExtra">
          <a-form-model-item v-bind="formItemLayout2" :extra="$t('ai.request_rate_limit_extra_1')">
            <a-switch v-model="form.request_rate_limit" />
          </a-form-model-item>
          <template v-if="form.request_rate_limit">
            <a-form-model-item v-bind="formItemLayout2" :label="$t('ai.request_rate_limit_duration')" prop="rate_limiting_interval" class="mb-0">
              <a-select v-model="form.rate_limiting_interval">
                <a-select-option v-for="item in rateLimitingIntervalOptions" :key="item.value" :value="item.value">{{ item.label }}</a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item v-bind="formItemLayout2" :label="$t('ai.request_rate_limit_limit')" prop="rate_limiting_limit" class="mb-0">
              <a-input-number v-model="form.rate_limiting_limit" :min="1" />
            </a-form-model-item>
            <a-form-model-item v-bind="formItemLayout2" :label="$t('ai.request_rate_limit_technique')" prop="rate_limiting_technique" class="mb-0">
              <a-radio-group v-model="form.rate_limiting_technique">
                <a-radio value="fixed">{{ $t('ai.request_rate_limit_technique_fixed') }}</a-radio>
                <a-radio value="sliding">{{ $t('ai.request_rate_limit_technique_sliding') }}</a-radio>
              </a-radio-group>
            </a-form-model-item>
          </template>
        </a-form-model-item>
        <a-form-model-item :label="$t('ai.enable_authentication')" :extra="$t('ai.enable_authentication_extra')">
          <a-switch v-model="form.authentication" />
        </a-form-model-item>
      </a-form-model>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'
import { validateModelForm } from '@/utils/validate'
import { rateLimitingIntervalOptions, cacheTtlOptions } from '../constants'

export default {
  name: 'AiGatewayCreateDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    const { type, data } = this.params
    let initName = ''
    let initCollectLogs = true
    let initCacheResponse = false
    let initRequestRateLimit = false
    let initAuthentication = false
    let initCacheTtl = 60
    let initRateLimitingInterval = 60
    let initRateLimitingLimit = 50
    let initRateLimitingTechnique = 'fixed'
    if (type === 'update') {
      initName = data[0].name
      initCollectLogs = data[0].collect_logs
      if (data[0].cache_ttl) {
        initCacheResponse = true
        initCacheTtl = data[0].cache_ttl
      }
      if (data[0].rate_limiting_interval) {
        initRequestRateLimit = true
        initRateLimitingInterval = data[0].rate_limiting_interval
        initRateLimitingLimit = data[0].rate_limiting_limit
        initRateLimitingTechnique = data[0].rate_limiting_technique
      }
      if (data[0].authentication) {
        initAuthentication = data[0].authentication
      }
    }
    return {
      loading: false,
      form: {
        name: initName,
        collect_logs: initCollectLogs,
        // collect_logs_limit: 10000,
        // collect_logs_over_limit: 'rewrite',
        cache_response: initCacheResponse,
        cache_ttl: initCacheTtl,
        request_rate_limit: initRequestRateLimit,
        rate_limiting_interval: initRateLimitingInterval,
        rate_limiting_limit: initRateLimitingLimit,
        rate_limiting_technique: initRateLimitingTechnique,
        authentication: initAuthentication,
      },
      rules: {
        name: { required: true, validator: this.$validate('resourceName') },
        cloudprovider: { required: true, message: this.$t('common.tips.select', [this.$t('compute.text_653')]) },
      },
      formItemLayout: {
        wrapperCol: {
          span: 20,
        },
        labelCol: {
          span: 4,
        },
      },
      formItemLayout2: {
        wrapperCol: {
          span: 20,
        },
        labelCol: {
          span: 4,
        },
      },
      rateLimitingIntervalOptions,
      cacheTtlOptions,
      cloudProviderParams: {
        scope: this.$store.getters.scope,
        limit: 20,
        provider: 'Cloudflare',
      },
    }
  },
  computed: {
    ...mapGetters(['isAdminMode', 'isDomainMode', 'scope', 'userInfo']),
    rateLimitExtra () {
      if (this.form.request_rate_limit) {
        const target = this.rateLimitingIntervalOptions.filter(item => item.value === this.form.rate_limiting_interval)
        return this.$t(`ai.request_rate_limit_technique_${this.form.rate_limiting_technique}_extra`, [target.length ? target[0].label : this.form.rate_limiting_interval / 60 + 'Min', this.form.rate_limiting_limit])
      }
      return ''
    },
  },
  methods: {
    genParams () {
      const params = {
        name: this.form.name,
        cloudprovider: this.form.cloudprovider,
        collect_logs: this.form.collect_logs,
        // collect_logs_limit: this.form.collect_logs_limit,
        // collect_logs_over_limit: this.form.collect_logs_over_limit,
        cache_ttl: this.form.cache_response ? this.form.cache_ttl : 0,
        rate_limiting_interval: this.form.request_rate_limit ? this.form.rate_limiting_interval : 0,
        rate_limiting_limit: this.form.request_rate_limit ? this.form.rate_limiting_limit : 0,
        rate_limiting_technique: this.form.request_rate_limit ? this.form.rate_limiting_technique : 'fixed',
        authentication: this.form.authentication,
      }
      return params
    },
    async handleConfirm () {
      this.loading = true
      try {
        await validateModelForm(this.$refs.form)
        const data = this.genParams()
        if (this.params.type === 'create') {
          await this.params.onManager('create', {
            managerArgs: {
              data,
            },
          })
        } else {
          await this.params.onManager('performAction', {
            id: this.params.data[0].id,
            steadyStatus: ['available'],
            managerArgs: {
              action: 'change-config',
              data,
            },
          })
        }
        this.loading = false
        this.cancelDialog()
      } catch (error) {
        this.loading = false
        throw error
      }
    },
  },
}
</script>
